import { gql } from '@apollo/client';

export const getProductsSupplier = gql`
  query GetProductSupplier {
    productSuppliersByProviderKrn(
      providerKrn: "krn:kizi:data-provider:breedbandwinkel"
      productCategory: TRIPLE_PLAY
    ) {
      id
      krn
      name
      legalName
      externalIds {
        providerKrn
        externalSupplierId
      }
      porCompany
      state
      features {
        name
        value
        productCategory
      }
      nameLogoUrl
      addresses {
        id
        addressType
        city
        country
        houseNumber
        houseNumberAddition
        postalCode
        street
      }
      informationContacts {
        id
        type
        replyNumber
        phoneNumber
        emailAddress
      }
      advantages {
        description
        productCategory
      }
      disadvantages {
        description
        productCategory
      }
      taskDivisions {
        id
        clientName
        value
        productCategory
        name
      }
      howItWorks {
        id
        clientName
        productCategory
        typeName
        value
      }
      sellingPoints {
        id
        productCategory
        value
        clientName
        description
        orderType
        sellingPointType
      }
      sustainabilityScore {
        score
        source
      }
      about
      customAttributes {
        description
        value
      }
    }
  }
`;

export default getProductsSupplier;
